var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer-reports"},[(_vm.isScoringEnabled)?_c('scoring-request-list',{attrs:{"criteria":_vm.customer.idCode,"customer":_vm.customer,"disable-filters":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }